import React from 'react';
import { useTranslation } from 'react-i18next';

import { STATIC_PAGES_LINKS } from '../../../../../const';
import styles from './styles.module.scss';

const staticLinksConfig = [
    {
        label: 'footer.about',
        link: STATIC_PAGES_LINKS.ABOUT
    },
    {
        label: 'footer.contact',
        link: STATIC_PAGES_LINKS.CONTACT
    },
    {
        label: 'footer.advertising',
        link: STATIC_PAGES_LINKS.ADVERTISING
    },
    {
        label: 'footer.privacy',
        link: STATIC_PAGES_LINKS.PRIVACY
    },
    {
        label: 'footer.terms',
        link: STATIC_PAGES_LINKS.TERMS
    }
];
export const StaticPagesList = () => {
    const { t } = useTranslation();
    return (
        <ul className={styles.menu}>
            {staticLinksConfig.map((item) => (
                <li key={item.link}>
                    <a href={item.link} target="_blank" className={styles.link}>
                        {t(item.label)}
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default StaticPagesList;
